// extracted by mini-css-extract-plugin
module.exports = {"root":"Picture_root__3ivmt","image":"Picture_image__vGN9W","info":"Picture_info__Y0_dp","caption":"Picture_caption__XQckN","copyright":"Picture_copyright__6AvEw"};